import moment from 'moment';

export function getLaterDate(a: string | null, b: string | null) {
  if (a && b) return moment(a).isAfter(moment(b)) ? a : b;
  if (a) return a;
  if (b) return b;
  return null;
}
